export enum WhoIsStatusEnum {
  NoWhois = 0,
  Approved = 1,
  Rejected = 2,
  StatusCheck = 3,
  Expired = 4,
  PendingInquiry = 5,
}
